import { FC } from "react";

import Colors from "@constants/Colors";

interface AlertTriangleTypes {
  color?: string;
  height?: string;
  width?: string;
  strokeWidth?: string;
}

const AlertTriangle: FC<AlertTriangleTypes> = ({
  color,
  width,
  height,
  strokeWidth,
}) => {
  return (
    <svg
      width={width || "12"}
      height={height || "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3742_1082)">
        <path
          d="M5.14489 1.9301L0.909888 9.0001C0.822572 9.15131 0.776372 9.32275 0.775883 9.49736C0.775394 9.67197 0.820634 9.84367 0.907102 9.99536C0.993569 10.1471 1.11825 10.2735 1.26874 10.362C1.41923 10.4506 1.59029 10.4982 1.76489 10.5001H10.2349C10.4095 10.4982 10.5805 10.4506 10.731 10.362C10.8815 10.2735 11.0062 10.1471 11.0927 9.99536C11.1791 9.84367 11.2244 9.67197 11.2239 9.49736C11.2234 9.32275 11.1772 9.15131 11.0899 9.0001L6.85489 1.9301C6.76575 1.78316 6.64025 1.66166 6.49049 1.57734C6.34072 1.49303 6.17176 1.44873 5.99989 1.44873C5.82802 1.44873 5.65905 1.49303 5.50929 1.57734C5.35953 1.66166 5.23402 1.78316 5.14489 1.9301V1.9301Z"
          stroke={color}
          strokeWidth={strokeWidth || "1.5"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 4.5V6.5"
          stroke={color}
          strokeWidth={strokeWidth || "1.5"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8.5H6.00393"
          stroke={color}
          strokeWidth={strokeWidth || "1.5"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3742_1082">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

AlertTriangle.defaultProps = {
  color: Colors.neutralblack,
  width: "12",
  height: "12",
  strokeWidth: "1.5",
};

export default AlertTriangle;
